import i18n from 'helper/i18n';
import { filterForTag } from './utils';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';

export const FILTER_ID = 'RECIPE_TOGO' as const;

export const DURATION_TAG = {
	ACTIVE: '307',
} as const;

export const TAG_ID = {
	OCCASIONS: 'occasions',
} as const;

export const FILTER_FACTORY = {
	ACTIVE: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.OCCASIONS, DURATION_TAG.ACTIVE),
	NONE: (item: ContentTypePoolRecipeDtoType) => true,
};

export const FILTER = {
	ACTIVE: 'ACTIVE',
} as const;

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	ACTIVE: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.ACTIVE}`),
};

export function filterForTogo(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => {
		return FILTER_FACTORY[filter[0]](item);
	};
}

export default filterForTogo;
